import environment from "../config/environment";

export const priceValidityInSeconds = 3600;

export const ASSET_IMAGE_URL_PREFIX = `${environment['ES_CDN_BASE_URL']}/uploads/small`;
